import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '../../notes/icon/icon.module';
import { StatusModule } from '../../notes/status/status.module';

import { InboxComponent } from './inbox.component';

@NgModule({
  declarations: [InboxComponent],
  imports: [StatusModule, CommonModule, IconModule],
  exports: [InboxComponent],
})
export class InboxModule {}
